// @flow
import * as React from 'react';

import Link from 'components/Link.jsx';
import Row from 'components/Row.jsx';
import Text from 'components/Text.jsx';

import './styles/WizardHelperText.scss';

type Props = {
  text: string,
  linkLabel: string,
  onClickLink: () => void,
};

export default class WizardHelperText extends React.PureComponent<Props> {
  render() {
    const { text, linkLabel, onClickLink } = this.props;

    return (
      <div className="WizardHelperText">
        <Text align="left" size="xsmall">
          <Row size="xsmall">
            <Text color="thunder">{text}</Text>
          </Row>
          <Link onClick={onClickLink}>
            <Text weight="semibold">{linkLabel}</Text>
          </Link>
        </Text>
      </div>
    );
  }
}
